import { z } from 'zod';
import { displayNameSchema } from './schemas.js';
/**
 * HTTP API: аккаунт, контент, прогресс (SPEC.md, раздел 17).
 * Socket.IO остаётся только для матчей; токен сессии аккаунта передаётся в заголовке
 * `Authorization: Bearer <token>`.
 */
export const API_PREFIX = 'api';
export const ApiRoute = {
    AccountGuest: 'accounts/guest',
    AccountRegister: 'accounts/register',
    AccountLogin: 'accounts/login',
    AccountLogout: 'accounts/logout',
    AccountMe: 'accounts/me',
    Content: 'content',
    Progress: 'progress',
    Attempts: 'attempts',
    /** Отметки «уже видел» и настройки. */
    Profile: 'profile',
    ProfileSeen: 'profile/seen',
    ProfileSettings: 'profile/settings',
    /** Каталог магазина, предметы игрока и надетые скины. */
    Shop: 'shop',
    ShopEquip: 'shop/equip',
};
/** Отправка журнала партии: `POST attempts/:id/result`. */
export const attemptResultRoute = (attemptId) => `attempts/${attemptId}/result`;
/** Токен сессии аккаунта: 32 случайных байта в base64url. */
export const ACCOUNT_TOKEN_PATTERN = /^[A-Za-z0-9_-]{43}$/;
export const PASSWORD_MIN_LENGTH = 8;
export const PASSWORD_MAX_LENGTH = 128;
export const emailSchema = z.string().trim().toLowerCase().max(254).pipe(z.email());
export const passwordSchema = z.string().min(PASSWORD_MIN_LENGTH).max(PASSWORD_MAX_LENGTH);
/** Регистрация превращает текущий гостевой аккаунт в полноценный (SPEC.md, раздел 17.2). */
export const registerSchema = z.strictObject({
    email: emailSchema,
    password: passwordSchema,
    name: displayNameSchema,
});
export const loginSchema = z.strictObject({
    email: emailSchema,
    // При входе длину не проверяем строго: неверный пароль — обычная ошибка входа.
    password: z.string().min(1).max(PASSWORD_MAX_LENGTH),
});
export const ACCOUNT_KINDS = ['guest', 'registered'];
export const ApiErrorCode = {
    InvalidRequest: 'invalid-request',
    Unauthorized: 'unauthorized',
    RateLimited: 'rate-limited',
    EmailTaken: 'email-taken',
    InvalidCredentials: 'invalid-credentials',
    AlreadyRegistered: 'already-registered',
    NotFound: 'not-found',
    /** Уровень ещё не открыт. */
    LevelLocked: 'level-locked',
    /** Попытка устарела — начните уровень заново. */
    AttemptExpired: 'attempt-expired',
    /** Журнал не воспроизводится: команда отклонена движком или партия не завершена. */
    InvalidReplay: 'invalid-replay',
    /** Предмета нет у игрока (или он не подходит к слоту). */
    ItemNotOwned: 'item-not-owned',
};
//# sourceMappingURL=api.js.map